import { environment } from '@env/environment.local';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageLanguage } from '@app/_models/languages/language';
import { countryCodes } from '@app/_shared/data/country-codes';

@Component({
    selector: 'mc-language-select',
    templateUrl: './mc-language-select.component.html',
    styleUrls: ['./mc-language-select.component.scss'],
})
export class LanguageSelectComponent {
    @Input() idSelect: string;
    @Input() countries: PageLanguage[];
    @Input() defaultCountry: PageLanguage;
    @Input() nameKey: string = 'name';
    @Input() disabled: boolean = false;
    @Output() countrySelected: EventEmitter<PageLanguage> = new EventEmitter<PageLanguage>();
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    valueCode: string;
    srcImg: string;
    countryName: string;

    constructor() {}

    //Method change button stuff on click
    selectOption = (elem: PageLanguage) => {
        const countries = countryCodes;
        this.valueCode = elem.alpha2Code;
        // this.srcImg = countries.find((c) => c.alpha2Code === elem.alpha2Code)?.image_url;
        this.srcImg = `${this.countries.find((c) => c.alpha2Code === elem.alpha2Code)?.alpha2Code?.toLowerCase()}.png`;
        this.countryName = elem[this.nameKey];
        this.toggleClass();
        this.countrySelected.emit(elem);
    };

    getFlag(country: PageLanguage) {
        // const countries = countryCodes;
        // const srcImg = countries.find((c) => c.alpha2Code === country.alpha2Code)?.image_url;
        // return srcImg ?? '';
        const srcImg = `${this.countries
            .find((c) => c.alpha2Code === country.alpha2Code)
            ?.alpha2Code?.toLowerCase()}.png`;
        return srcImg ?? '';
    }

    toggleClass() {
        document.getElementById(this.idSelect)?.classList.toggle('d-none');
    }

    hideSelect() {
        document.getElementById(this.idSelect)?.classList.add('d-none');
    }
}
